import { OrganizationTypes } from '../../../../../../primary-record-types';
import React, { useEffect } from 'react';
import LogList, { LogPressArgs } from '../../../../../shared/LogList/LogList';
import { ActionButtonLayout } from '../../../../../v2BaseComponents/ActionButtonLayout';
import { getIntl } from '../../../../../../utils/intl';
import AuditLogDetails, { useDeleteAuditLogActionButton } from '../../../../../shared/AuditLogDetails';
import { ProAppProfilesProvider } from '../../../../../shared/LogList';
import { View } from 'react-native';

const intl = getIntl('client-record-activity', {
    backToList: 'Back to list',
});

export type ClientRecordActivityOwnProps = {
    activeClientRecord: OrganizationTypes.OrganizationClientRecordForStatus<'active'>;
};

export type ClientRecordActivityProps = ClientRecordActivityOwnProps;

const ClientRecordActivityDetails: React.FC<{ auditLogId: string; profileId: string; onDismiss: () => void }> = ({
    auditLogId,
    profileId,
    onDismiss,
}) => {
    const { deleteAuditLogAction } = useDeleteAuditLogActionButton({
        auditLogId,
        medicalProfileFileId: profileId,
        onDeleted: onDismiss,
    });

    return (
        <ActionButtonLayout
            actions={[
                deleteAuditLogAction,
                {
                    title: intl('backToList'),
                    icon: 'ArrowLeft',
                    onPress: onDismiss,
                    variant: 'secondary',
                    testID: 'back-to-client-activity-list-button',
                },
            ]}
            scrollable
        >
            <AuditLogDetails auditLogId={auditLogId} profileId={profileId} />
        </ActionButtonLayout>
    );
};

const ClientRecordActivity: React.FC<ClientRecordActivityProps> = (props) => {
    const [focusedLogPressArgs, setFocusedLogPressArgs] = React.useState<LogPressArgs | null>(null);

    useEffect(() => {
        if (focusedLogPressArgs && !focusedLogPressArgs.medicalProfileId) {
            setFocusedLogPressArgs(null);
        }
    }, [focusedLogPressArgs]);

    if (focusedLogPressArgs && !focusedLogPressArgs.medicalProfileId) return null;

    if (focusedLogPressArgs && focusedLogPressArgs.medicalProfileId) {
        return (
            <ClientRecordActivityDetails
                auditLogId={focusedLogPressArgs.auditLogId}
                profileId={focusedLogPressArgs.medicalProfileId}
                onDismiss={() => setFocusedLogPressArgs(null)}
            />
        );
    } else {
        return (
            <ProAppProfilesProvider medicalProfileIds={[props.activeClientRecord.clientMedicalProfileId]}>
                {(state) => (
                    <View style={{ width: '100%', height: '100%' }} testID="log-list-container" collapsable={false}>
                        <LogList {...state} disableSelection onLogPress={setFocusedLogPressArgs} />
                    </View>
                )}
            </ProAppProfilesProvider>
        );
    }
};

export default React.memo(ClientRecordActivity);
